if (!customElements.get('ntod-product-accordion')) {
  customElements.define('ntod-product-accordion', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.cards = [...this.querySelectorAll('[data-accordion-card]')];
      const activate = card => this.cards.forEach(item => item.classList.toggle('is-active', item === card));
      this.cards.forEach(card => {
        card.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') activate(card); }, {signal});
        card.addEventListener('focusin', () => activate(card), {signal});
        card.addEventListener('keydown', event => {
          const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (!keys.includes(event.key) || !matchMedia('(min-width: 750px)').matches) return;
          event.preventDefault();
          const index = this.cards.indexOf(card);
          let next = event.key === 'ArrowLeft' ? index - 1 : index + 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.cards.length - 1;
          this.cards[(next + this.cards.length) % this.cards.length].querySelector('a')?.focus();
        }, {signal});
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
if (!customElements.get('ntod-mobile-purchase')) {
  customElements.define('ntod-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.main = document.querySelector('product-info[data-update-url="true"]');
      this.button = this.querySelector('[data-purchase-button]');
      this.price = this.querySelector('[data-purchase-price]');
      if (!this.main || !this.button || !this.price) return;
      this.sync = () => {
        const sectionId = this.main.dataset.section;
        const native = this.main.querySelector('#ProductSubmitButton-' + sectionId);
        const source = this.main.querySelector('#price-' + sectionId + ' .price');
        const variant = this.main.querySelector('#product-form-' + sectionId + ' input[name="id"]');
        if (!native || !variant) { this.hidden = true; return; }
        this.hidden = false;
        this.button.disabled = native.disabled || native.getAttribute('aria-disabled') === 'true' || variant.disabled || !variant.value;
        this.button.textContent = native.querySelector('span')?.textContent.trim() || native.textContent.trim();
        this.button.setAttribute('aria-busy', String(native.classList.contains('loading')));
        this.price.hidden = !source || source.parentElement.classList.contains('hidden');
        if (source && this.price.innerHTML !== source.outerHTML) {
          this.price.innerHTML = source.outerHTML;
          this.price.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        }
      };
      this.button.addEventListener('click', () => {
        this.sync();
        if (this.button.disabled) return;
        this.main.querySelector('#ProductSubmitButton-' + this.main.dataset.section)?.click();
      }, {signal:this.controller.signal});
      this.observer = new MutationObserver(() => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      });
      this.observer.observe(this.main, {childList:true, subtree:true, attributes:true, characterData:true});
      this.main.addEventListener('change', this.sync, {signal:this.controller.signal});
      this.resizeObserver = new ResizeObserver(() => document.documentElement.style.setProperty('--ntod-purchase-height', this.getBoundingClientRect().height + 'px'));
      this.resizeObserver.observe(this);
      document.addEventListener('shopify:section:load', () => this.connectedCallback(), {signal:this.controller.signal});
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
